import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'CubeSendIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cube-send",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M16 12.5l-5 -3l5 -3l5 3v5.5l-5 3z"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M11 9.5v5.5l5 3"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M16 12.545l5 -3.03"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7 9h-5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7 12h-3"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7 15h-1"
    }, null), _createTextVNode(" ")]);
  }
};